import { render, staticRenderFns } from "./KidsProducts.vue?vue&type=template&id=19727486&scoped=true&"
import script from "./KidsProducts.vue?vue&type=script&lang=js&"
export * from "./KidsProducts.vue?vue&type=script&lang=js&"
import style0 from "./KidsProducts.vue?vue&type=style&index=0&id=19727486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19727486",
  null
  
)

export default component.exports